import { useEffect, useRef } from 'react'

type TUnknownFn = (...args: unknown[]) => unknown

export function useDelayedFn(fn: undefined, ms: number): undefined
export function useDelayedFn<T extends TUnknownFn>(
  fn: T,
  ms: number,
): (...args: Parameters<T>) => Promise<ReturnType<T>>
export function useDelayedFn<T extends TUnknownFn>(
  fn: T | undefined,
  ms: number,
): ((...args: Parameters<T>) => Promise<ReturnType<T>>) | undefined

export function useDelayedFn<T extends TUnknownFn>(
  fn: T | undefined,
  ms: number,
): ((...args: Parameters<T>) => Promise<ReturnType<T>>) | undefined {
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(
    () => () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current)
    },
    [],
  )

  if (!fn) return fn

  return (...args) =>
    new Promise<ReturnType<T>>((resolve) => {
      // oxlint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- generic boundary
      timeoutRef.current = setTimeout(() => resolve(fn(...args) as ReturnType<T>), ms)
    })
}
